import PagePlaceholder from '../components/PagePlaceholder.jsx';

export default function RegisterVenue() {
  return (
    <PagePlaceholder
      title="Register your venue"
      note="Venue sign-up. Linked from the landing page CTAs."
    />
  );
}
